import { useDispatch, useSelector } from "react-redux";
import { guestAccessAttempt } from "../../../features/guest/guestSlice";
import { FrameContent, FrameHeading, Lesson, Text } from "./TopicsStyle"
import { TopicData } from "./TopicsData"
import { speaking } from "../../../i18n/09_speaking";

// const lessons = Array.from({ length: 30 }, (_, i) => `Lesson ${i + 1}`);

const Topics = ({ isLessonUnlocked, clickLesson, isGuest }) => {
  const lang = useSelector(state => state.lang.lang)
  const t = speaking[lang]

  const dispatch = useDispatch()

  return (
    <FrameContent>
      <FrameHeading>{t.listOfLessons}</FrameHeading>
      {TopicData.map((value, index) => {
        const lessonNumber = index + 1
        const unlocked = isLessonUnlocked ? isLessonUnlocked(lessonNumber) : true

        const handleClick = () => {
          if (isGuest) {
            dispatch(guestAccessAttempt());
            return;
          }
          if (!unlocked) return
          clickLesson(lessonNumber)
        }


        return (
          <Text
            key={index}
            onClick={handleClick}
          >
            <Lesson>
              Lesson {index + 1}.
            </Lesson>
            {value.topic}
          </Text>
        )
      })}
    </FrameContent>
  )
}

export default Topics